module.exports = __webpack_public_path__ + "static/media/ChairCracked_After.3184079f.jpg";